import DynamicTagFallbackModal from './DynamicTagFallbackModal';

export default DynamicTagFallbackModal;
